import Tippy from "@tippyjs/react";
import "tippy.js/themes/light.css";
// import { t } from "i18next";
import React, { useState } from "react";
import "../../assets/CSS/test.css";

const MenuItem = ({
    children,
    content,
    allowHTML = false,
    disabled = false,
}) => {
    const [visible, setVisible] = useState(false);
    const hide = () => setVisible(false);
    const toggle = (e) => {
        e.stopPropagation();
        setVisible((prevVal) => !prevVal);
    };

    const handelClick = (item) => {
        hide();
        item.handler(item);
    };

    const renderContent = () => {
        if (allowHTML) {
            return content;
        }
        return content?.map((item, key) => (
            <button
                key={key}
                onClick={(e) => {
                    e.stopPropagation();
                    handelClick(item);
                }}
                id={`equation-dropdown-btn-${key}`}
            >
                <span className="flex items-center gap-2">
                    {item.icon && <i className={`${item.icon} fa-sm`} />}
                    {item.displayName || item.label}
                </span>
            </button>
        ));
    };

    return (
        <div className={`action-wrapper ${disabled ? "disabled" : ""}`}>
            <Tippy
                visible={visible}
                content={renderContent()}
                onClickOutside={hide}
                theme="light"
                interactive="true"
                placement="top"
                // appendTo={document.body}
            >
                <span onClick={toggle}>{children}</span>
            </Tippy>
        </div>
    );
};

export default MenuItem;
